<mat-stepper
  labelPosition="bottom"
  [linear]="isLinear"
  #stepper
  (click)="navigateData($event)"
  [selectedIndex]="selectedStepperIndex"
  class="mat-stepper-content"
>
  <mat-step
    [stepControl]="firstFormGroup"
    *ngIf="user && storageservice.checkUserRole(user.user.role_id, 'teacher')"
    [editable]="true"
  >
    <ng-template matStepLabel>Personal Information</ng-template>
  </mat-step>
  <mat-step
    [stepControl]="secondFormGroup"
    *ngIf="user && (storageservice.checkUserRole(user.user.role_id, 'teacher') || storageservice.checkUserRole(user.user.role_id, 'teacher_only'))"
    [editable]="true"
  >
    <ng-template matStepLabel>Academic Information</ng-template>
  </mat-step>
  <mat-step
    [stepControl]="thirdFormGroup"
    *ngIf="user && storageservice.checkUserRole(user.user.role_id, 'teacher')"
    [editable]="true"
  >
    <ng-template matStepLabel>Bell Schedule</ng-template>
  </mat-step>

  <mat-step
    [stepControl]="fourthFormGroup"
    *ngIf="user && storageservice.checkUserRole(user.user.role_id, 'admin')"
    [editable]="true"
  >
    <ng-template matStepLabel>School Instructions Periods</ng-template>
  </mat-step>
  <mat-step
    [stepControl]="fifthFormGroup"
    *ngIf="user && storageservice.checkUserRole(user.user.role_id, 'admin')"
    [editable]="true"
  >
    <ng-template matStepLabel>School Calendar</ng-template>
  </mat-step>

  <mat-step
    [stepControl]="thirdFormGroup"
    *ngIf="user && storageservice.checkUserRole(user.user.role_id, 'teacher_only')"
    [editable]="true"
  >
    <ng-template matStepLabel>Calendar Setup</ng-template>
  </mat-step>
</mat-stepper>
